// extracted by mini-css-extract-plugin
export default {"columnWith":"ISubmitterEntries_columnWith__sZ-I8","btnColumn":"ISubmitterEntries_btnColumn__jEKeX"};